import axios from 'axios'
import store from '@/store'
import router from '@/router'

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    // Common header patterns
    if (!config.headers) config.headers = {}
    // Authorization header
    const hasBearer = /^Bearer\s+/i.test(token)
    config.headers['Authorization'] = hasBearer ? token : `Bearer ${token}`
    // Fallback custom headers for compatibility
    config.headers['token'] = token
    config.headers['X-Token'] = token
  }
  return config
}, (error) => Promise.reject(error))

// 兼容不同环境（axios 在浏览器/Node 返回的 headers 可能是普通对象，fetch 返回的是 Headers 对象）
const getHeader = (res, name) => {
  const headers = res && res.headers
  if (!headers) return undefined
  // If it's a Fetch Headers instance
  if (typeof headers.get === 'function') return headers.get(name)
  // Otherwise assume plain object; try exact key then case-insensitive lookup
  if (Object.prototype.hasOwnProperty.call(headers, name)) return headers[name]
  const lower = name.toLowerCase()
  const found = Object.keys(headers).find(k => k.toLowerCase() === lower)
  return found ? headers[found] : undefined
}

// 检查响应头中的 token 并更新到 localStorage
const updateTokenFromResponse = (res) => {
  if (!res) return
  const newToken = getHeader(res, 'New-Token') || getHeader(res, 'new-token')
  if (newToken) {
    localStorage.setItem('token', newToken)
  }
}

axios.interceptors.response.use((response) => {
  // 在成功响应中检查并更新 token
  updateTokenFromResponse(response)
  return response
}, (error) => {
  const status = error?.response?.status
  if (status === 401 || status === 403) {
    try { 
      store.dispatch('user/logout') 
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('logout dispatch failed:', e)
    }
    if (router.currentRoute.path !== '/login') {
      router.replace('/login')
    }
  }

  // 在错误响应中也检查并更新 token
  updateTokenFromResponse(error?.response)

  return Promise.reject(error)
})
